<template>
  <div v-if="visible" class="loading-container">
    <div class="loading-wrapper">
      <img src="@/assets/img/logo/loading.svg" alt="loading" class="loading-logo" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background-color: #162447; */
  background-image: url('~@/assets/img/bg_schedule.webp');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  pointer-events: none;
  user-select: none;
}

.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-logo {
  width: 50px;
  height: 50px;
  animation: breathe 3s ease-in-out infinite;
}

@keyframes breathe {
  0%, 100% {
    opacity: 0.3;
    filter: brightness(0.3);
  }
  50% {
    opacity: 1;
    filter: brightness(1);
  }
}

/* PC 端适配 */
@media (min-width: 768px) {
  .loading-logo {
    width: 70px;
    height: 70px;
  }
}

/* 大屏设备适配 */
@media (min-width: 1200px) {
  .loading-logo {
    width: 90px;
    height: 90px;
  }
}

/* 小屏移动端适配 */
@media (max-width: 375px) {
  .loading-logo {
    width: 40px;
    height: 40px;
  }
}
</style>
